var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[(_vm.icon)?_c('v-icon',{staticClass:"mr-3",attrs:{"color":_vm.color,"size":"28"},domProps:{"textContent":_vm._s(_vm.icon)}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),(_vm.text)?_c('div',{staticClass:"subtitle-1",domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }